// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__3MKyK","stats__wrapper":"Stats_stats__wrapper__ffZIP"};